import { useTelegram } from '@st/telegram/composables/useTelegram'

export default defineNuxtPlugin({
  order: 7,
  name: 'telegramInWebWatcher',
  setup() {
    const router = useRouter()
    const { isTgMiniAppInSafari } = useTelegram()
    if (isTgMiniAppInSafari.value) {
      router.replace({ query: { modal: 'webTelegramForbidden' } })
    }
  },
})
